// import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import cookie from './utils/cookie'

// 获取链接上的im账号密码
let search = window.location.search.substring(1).split('&'),
	args = {};
for(let i = 0; i < search.length; i++){
	let item = search[i].split('='),
		name = decodeURIComponent(item[0]),
		value = decodeURIComponent(item[1]);
    if(name.length){
        args[name] = value;
    }
}
cookie.setCookie('uid', args.account)
cookie.setCookie('sdktoken', args.password)
if(args.staff_account){
  cookie.setCookie('staff_account', args.staff_account)
}else{
  if(cookie.readCookie('staff_account')){
    cookie.delCookie('staff_account')
  }
}


// // 添加Fastclick移除移动端点击延迟
// import FastClick from 'fastclick'
// FastClick.attach(document.body)

// 添加手势触摸事件，使用方法如 v-touch:swipeleft
import VueTouch from './plugins/touchEvent'
Vue.use(VueTouch)

// import VueRecyclerviewNew from 'vue-recyclerview'
// Vue.use(VueRecyclerviewNew)

// 同步单页路由与数据中心
import store from './store'
import router from './router'

require('./utils/polyfill')

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js